import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Loading from "../../components/Genericos/Loading/Loading";
import Modal from "../../components/Genericos/Modal/Modal";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import BuscadorConsultaMedica from "../../components/Turnos/BuscadorConsultaMedica/BuscadorConsultaMedica";
import MultitabHome from "../../components/Turnos/MultitabHome/MultitabHome";
import MultitabMobile from "../../components/Turnos/MultitabMobile/MultitabMobile";
import {
  LimpiarSelectCM,
  LimpiarSelectGlobal,
  SelectUserCM,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import {
  estudioGrupo,
  filtrarEstudioGrupoPorEdad,
} from "../../context/Actions/estudioGrupo/estudioGrupo";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "../../context/Actions/laboGrupo/laboGrupo";
import { showModal } from "../../context/Actions/modal/modal";
import { logoutConsultaMedTurnos } from "../../context/Actions/turnos/consultaMedTurnos";
import { logoutEstudiosTurnos } from "../../context/Actions/turnos/estudioTurnos";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { PortalContext } from "../../context/Provider";
import { displayAyudaMobile } from "../../../global/utils/ayuda";
import { multiTabsData } from "../../../global/utils/multiTabData";
import "./ConsultaMedica.css";
import { GlobalContext } from "../../../global/context/Provider";

import routes from "_+_Portal/routes/listRoutes";
import BuscadorTurnos from "../BuscadorTurnos/BuscadorTurnos";
import { wsGetTextos } from "_+_Portal/context/Actions/textos/textos";
import { showToaster } from "global/context/action/toaster/toaster";
import { motion } from "framer-motion";
import { pageContainerVariants } from "global/utils/cardAnimation";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";
import BottomNavbar from "_+_Portal/components/Genericos/BottomNavbar/BottomNavbar";
import "_+_Portal/components/Genericos/BottomNavbar/BottomNavbar.css";

const ConsultaMedica = () => {
  const history = useHistory();
  const {
    estudioGrupoDispatch,
    estudioGrupoState,
    modalState,
    laboGrupoState,
    laboGrupoDispatch,
    modalDispatch,
    selectDropDownDispatch,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    estudioTurnosDispatch,
    consultaMedTurnosDispatch,
    textosState,
    presentismoState,
    textosDispatch,
    listaFamiliaresState,
    selectDropDownState,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, toasterState, toasterDispatch, configState } =
    useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [tabsData, setTabsData] = useState(multiTabsData);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onClickMultitabHome = (e) => {
    if (configState.config.data.opcBuscadorTurnos) {
      const index = routes.findIndex((objeto) => objeto.id === 30);
      if (index === -1) {
        routes.push({
          id: 30,
          path: "/buscadorTurnos",
          component: BuscadorTurnos,
          title: "Buscador Turnos",
          needsAuth: false,
        });
      }
    }
    history.push(e.path);
  };

  //repetir en las paginas para tener los datos de los grupos
  useEffect(() => {
    if (configState.config.data !== null) {
      if (estudioGrupoState.estudioGrupo.data === null) {
        estudioGrupo(authState?.auth?.data?.paciente)(estudioGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.data === null &&
        configState.config.data.opcLaboratorio
      ) {
        laboGrupo()(laboGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.centros === null &&
        configState.config.data.opcLaboratorio
      ) {
        wsGetLaboCentros()(laboGrupoDispatch);
      }
      displayAyudaMobile("visible");
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "CONSULTA_MEDICA"
      ) {
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
      }
    }
    //eslint-disable-next-line
  }, [configState.config.data]);

  // ONCHANGE DE LOS DROPDOWNS

  // estado de las preguntas covid
  // const [viewCovid, setViewCovid] = useState(true);

  const onChangeMultitabMobile = (e) => {
    const dataOriginal = estudioGrupoState.estudioGrupo.dataOriginal;

    if (e !== "") {
      if (
        e.id &&
        e.id !== authState.auth.data.paciente.codigo &&
        e.manejoTurnos
      ) {
        SelectUserCM({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        filtrarEstudioGrupoPorEdad(
          dataOriginal,
          e.paciente,
        )(estudioGrupoDispatch);
      } else if (e.id !== authState.auth.data.paciente.codigo) {
        showToaster(
          {
            texto: "No posees permisos para gestionar turnos de este familiar.",
            tipo: "warning",
          },
          "centroArriba",
        )(toasterDispatch);

        LimpiarSelectCM()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      } else {
        LimpiarSelectCM()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        filtrarEstudioGrupoPorEdad(
          dataOriginal,
          authState?.auth?.data?.paciente,
        )(estudioGrupoDispatch);
      }
    } else {
      LimpiarSelectCM()(selectDropDownDispatch);
    }
  };

  // variable que me avisa si hay que mostrar el welcome
  const [stateWelcome, setStateWelcome] = useState(true);

  useEffect(() => {
    if (configState.config.data !== null) {
      if (configState.config.data.opcVideotutoriales) {
        dataWelcome();
      } else {
        setStateWelcome(false);
      }
    }
  }, [configState.config.data]);

  const dataWelcome = () => {
    const resp = localStorage.getItem("welcomeActive");
    if (resp === "false") {
      setStateWelcome(false);
    } else {
      setStateWelcome(true);
    }
  };

  useEffect(() => {
    if (configState.config.data !== null) {
      let tabsAux = tabsData;
      if (configState.config.data.opcLaboratorio === false) {
        tabsAux = tabsAux.filter((i) => i.id !== 2);
      }
      if (configState.config.data.opcRecetaDigital === false) {
        tabsAux = tabsAux.filter((i) => i.id !== 3);
      }
      if (
        configState.config.data.opcRecetaDigital === false &&
        configState.config.data.opcLaboratorio === false &&
        configState.config.data.opcBuscadorTurnos === false
      ) {
        tabsAux = tabsAux.filter((i) => i.id !== 3 && i.id !== 2);
      }
      if (configState.config.data.opcBuscadorTurnos) {
        tabsAux = tabsAux.filter((i) => i.id !== 0 && i.id !== 1 && i.id !== 2);
      } else {
        tabsAux = tabsAux.filter((i) => i.id !== 5);
      }
      setTabsData(tabsAux);
    }
  }, [configState.config.data]);

  // ------------------------ MODAL PUBLICITARIO ------------------------------------

  useEffect(() => {
    let publicidad = textosState?.textos?.data?.publicidades;
    const view = JSON.parse(localStorage.getItem("publicidad_portal"));
    if (publicidad && publicidad.length > 0 && !view) {
      showModal(
        "Turnos/Publicidad/Publicidad",
        {
          publicidad: publicidad,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
  }, [
    textosState?.textos?.data?.publicidades,
    estudioGrupoState.estudioGrupo.loading,
  ]);

  useEffect(() => {
    //complemento textos siempre lo ultimo
    wsGetTextos()(textosDispatch);
  }, []);

  // Setear familiar desde URL (hash con parámetro familiar)
  useEffect(() => {
    const familiarDNI = sessionStorage.getItem("familiarHash");

    if (
      familiarDNI &&
      listaFamiliaresState.listaFamiliares.data &&
      !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
    ) {
      const familiarEncontrado = listaFamiliaresState.listaFamiliares.data.find(
        (fam) => fam.paciente?.nro_documento === familiarDNI,
      );

      if (familiarEncontrado) {
        if (familiarEncontrado.tipoDerecho?.manejoTurnos) {
          // Setear el familiar en el contexto
          SelectUserCM({
            id: familiarEncontrado.id,
            paciente: familiarEncontrado.paciente,
          })(selectDropDownDispatch);
          SelectUserGlobal({
            id: familiarEncontrado.id,
            paciente: familiarEncontrado.paciente,
          })(selectDropDownDispatch);
          // Filtrar grupos de estudio por edad del familiar
          filtrarEstudioGrupoPorEdad(
            estudioGrupoState.estudioGrupo.dataOriginal,
            familiarEncontrado.paciente,
          )(estudioGrupoDispatch);

          // Limpiar sessionStorage después de usar
          sessionStorage.removeItem("familiarHash");
        } else {
          // Familiar sin permisos
          showToaster(
            {
              texto: "El familiar no tiene permisos para gestionar turnos.",
              tipo: "warning",
            },
            "centroArriba",
          )(toasterDispatch);
          sessionStorage.removeItem("familiarHash");
        }
      } else {
        // Familiar no encontrado
        showToaster(
          {
            texto: "No se encontró el familiar especificado.",
            tipo: "warning",
          },
          "centroArriba",
        )(toasterDispatch);
        sessionStorage.removeItem("familiarHash");
      }
    }
  }, [listaFamiliaresState.listaFamiliares.data]);

  // ------------------------ MODAL PUBLICITARIO ------------------------------------

  return (
    <>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}

      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <Loading
        dataLoading={
          estudioGrupoState.estudioGrupo.loading ||
          presentismoState.presentismo.loading ||
          estudioGrupoState.estudioGrupo.data === null
        }
        color="c-white"
        descripcion={
          (estudioGrupoState.estudioGrupo.loading &&
            "Cargando consultas médicas...") ||
          (presentismoState.presentismo.loading && "Cargando turnos...") ||
          (estudioGrupoState.estudioGrupo.data === null &&
            "Cargando consultas médicas...")
        }
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Consulta Médica"} />
      <motion.div
        variants={pageContainerVariants(esMobile)}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        {estudioGrupoState.estudioGrupo.data &&
          !estudioGrupoState.estudioGrupo.loading && (
            <div className="ptur-bodyContainer-ConsultaMedica with-bottom-navbar">
              <Sidebar />
              <div className="ptur-consultaMedica-container">
                <TituloSaludo />
                <div className="ptur-consultaMedica-buscador">
                  <div className="ptur-consultaMedica-tabs">
                    <MultitabHome
                      tabs={tabsData}
                      onClick={onClickMultitabHome}
                    />
                  </div>
                  <BuscadorConsultaMedica
                    onChangeMultitabMobile={onChangeMultitabMobile}
                  />
                </div>
              </div>
            </div>
          )}
      </motion.div>

      {/* Bottom Navbar - Solo visible en móviles */}
      {esMobile && <BottomNavbar />}
    </>
  );
};

export default ConsultaMedica;
